module.exports = __webpack_public_path__ + "static/media/YB_GD_Background_Icon@2x.4d927e65.png";